import i18n from "@/i18n";

export interface EditorProfile {
    id: string,
    name: string,
    settingsJson: Array<EditorSettings>
}

export interface EditorSettings {
    name: string,
    items: Array<Item>,
    selectedItems: Array<string>
}

export interface EditorProfileSave {
    id: string,
    name: string,
    settingsJson: Array<EditorSettingsSave>
}

export interface EditorSettingsSave {
    name: string,
    selectedItems: Array<string>
}

export interface CustomItem {
    tooltipText: string,
    template: string
}

export const textItems = [
    { text: i18n.t("editorProfiles.items.font"), value: "fontselect" },
    { text: i18n.t("editorProfiles.items.fontSize"), value: "FontSizeWithInput" },
    { text: i18n.t("editorProfiles.items.bold"), value: "bold" },
    { text: i18n.t("editorProfiles.items.italic"), value: "italic" },
    { text: i18n.t("editorProfiles.items.strikethrough"), value: "strikethrough" },
    { text: i18n.t("editorProfiles.items.underline"), value: "underline" },
    { text: i18n.t("editorProfiles.items.bulletList"), value: "bullist" },
    { text: i18n.t("editorProfiles.items.image"), value: "customImagePlugin" },
    { text: i18n.t("editorProfiles.items.color"), value: "forecolor" },
    { text: i18n.t("editorProfiles.items.backColor"), value: "backcolor" },
    { text: i18n.t("editorProfiles.items.directFileUpload"), value: "directFileUploadPlugin" },
    { text: i18n.t("editorProfiles.items.stockImagesDownloadPlugin"), value: "stockImagesDownloadPlugin" },
    { text: i18n.t("editorProfiles.items.clearFormatting"), value: "removeformat" }
] as Array<Item>;

export const layoutItems = [
    { text: i18n.t("editorProfiles.items.alignLeft"), value: "alignleft" },
    { text: i18n.t("editorProfiles.items.alignCenter"), value: "aligncenter" },
    { text: i18n.t("editorProfiles.items.alignRight"), value: "alignright" },
    { text: i18n.t("editorProfiles.items.table"), value: "table" },
    { text: i18n.t("editorProfiles.items.selectTemplate"), value: "customTemplateSelect" },
    { text: i18n.t("editorProfiles.items.dragImage"), value: "dragImage" },
    { text: i18n.t("editorProfiles.items.draggableBox"), value: "draggableBox" }
] as Array<Item>;

export const miscItems = [
    { text: i18n.t("editorProfiles.items.undo"), value: "undo" },
    { text: i18n.t("editorProfiles.items.redo"), value: "redo" },
    { text: i18n.t("editorProfiles.items.tableBorder"), value: "tableBorderPlugin" },
    { text: i18n.t("editorProfiles.items.code"), value: "code" },
    { text: i18n.t("editorProfiles.items.backgroundSwap"), value: "backgroundSwapPlugin" },
    { text: i18n.t("editorProfiles.items.emoji"), value: "emoticons" }
] as Array<Item>;

export interface Item {
    text: string,
    value: string,
    order: number,
    custom: boolean | undefined
}

export interface Font {
    text: string,
    value: string,
    order: number
}

export const EditorSettings = [
    {
        name: "text",
        items: textItems,
        selectedItems: [] as Array<string>
    },
    {
        name: "layout",
        items: layoutItems,
        selectedItems: [] as Array<string>
    },
    {
        name: "misc",
        items: miscItems,
        selectedItems: [] as Array<string>
    }
] as Array<EditorSettings>;
